import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex shrink-0 items-center gap-2.5" }
const _hoisted_2 = { class: "flex flex-col gap-1" }
const _hoisted_3 = { class: "text-xs font-bold" }
const _hoisted_4 = ["href"]
const _hoisted_5 = ["href"]

import { useI18n } from 'vue-i18n';
    import type { User } from '@/types';
    import EmployeeAvatar from '../EmployeeAvatar.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerDashboardContact',
  props: {
    employee: {}
  },
  setup(__props: any) {

    const { t } = useI18n();

    const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(EmployeeAvatar, {
      user: _ctx.employee,
      class: "size-16 border-none"
    }, null, 8, ["user"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.employee.name), 1),
      _createElementVNode("a", {
        href: `mailto:${_ctx.employee.email}`,
        class: "text-xs hover:underline"
      }, _toDisplayString(_ctx.employee.email), 9, _hoisted_4),
      _createElementVNode("a", {
        href: `tel:${_ctx.employee.phone}`,
        class: "text-xs hover:underline"
      }, _toDisplayString(_ctx.employee.phone), 9, _hoisted_5)
    ])
  ]))
}
}

})